export default __webpack_public_path__ + "resources/icons/d420-c57d.png";